/* SHAMTAM collection page (T-COLLECTION-REDESIGN, Ent 230.116, 2026-10-15).
   Small glue around the theme's own <facet-filters> (assets/facet-filters.js) — no fetching of its own,
   no cart code (storefront cart features stay display-only):
   1. the filter panel is a drawer at EVERY width (the theme turns it into a fixed sidebar on desktop);
   2. the "Filter" button opens it;
   3. quick chips, applied-filter pills and "Clear all" are plain filter links: they go through the theme's
      applyFilters (section rendering + history), and simply navigate when the component is missing;
   4. the toolbar sort <select> sets the drawer's sort radio before facet-filters reads the form;
   5. the sticky toolbar sits under the sticky header. */
(() => {
  const ff = () => document.querySelector('facet-filters[data-shc]');

  function asDrawer(el) {
    if (!el || el.dataset.shcDrawer) return;
    el.dataset.shcDrawer = '1';
    if (el.breakpointChangeHandler) window.removeEventListener('on:breakpoint-change', el.breakpointChangeHandler);
    el.handleBreakpointChange = function () {
      if (this.hasAttribute('open') && !this.dataset.shcOpened) this.close();
      this.setAttribute('role', 'dialog');
      this.setAttribute('aria-modal', 'true');
      if (!this.hasAttribute('open')) this.setAttribute('aria-hidden', 'true');
      this.hidden = false;
    };
    el.breakpointChangeHandler = el.handleBreakpointChange.bind(el);
    window.addEventListener('on:breakpoint-change', el.breakpointChangeHandler);
    // The theme opened it as a sidebar on desktop during init: close without the slide.
    if (el.hasAttribute('open')) {
      el.removeAttribute('open');
      el.setAttribute('aria-hidden', 'true');
      document.querySelector('.js-overlay')?.classList.remove('is-visible');
    }
    el.handleBreakpointChange();
    el.addEventListener('on:facet-filters:after-close', () => { delete el.dataset.shcOpened; syncExpanded(false); });
    requestAnimationFrame(() => el.classList.add('shc-ready'));
  }

  function syncExpanded(open) {
    document.querySelectorAll('.js-shc-open-filters').forEach((b) => b.setAttribute('aria-expanded', open ? 'true' : 'false'));
  }

  customElements.whenDefined('facet-filters').then(() => asDrawer(ff()));

  document.addEventListener('click', (evt) => {
    const opener = evt.target.closest('.js-shc-open-filters');
    if (opener) {
      const el = ff();
      if (!el || typeof el.open !== 'function') return;
      el.dataset.shcOpened = '1';
      el.open(opener);
      syncExpanded(true);
      return;
    }
    const link = evt.target.closest('a.js-shc-ajax');
    if (link && !evt.metaKey && !evt.ctrlKey && !evt.shiftKey) {
      const el = ff();
      if (!el || typeof el.applyFilters !== 'function') return; // plain navigation
      evt.preventDefault();
      el.applyFilters(new URL(link.href, location.href).searchParams.toString(), evt);
    }
  });

  // Toolbar sort: mirror the choice into the drawer's sort_by radio, which is what the form submits.
  document.addEventListener('change', (evt) => {
    if (evt.target.id !== 'shc-sort-by') return;
    const radio = document.querySelector(`#facets input[name="sort_by"][value="${CSS.escape(evt.target.value)}"]`);
    if (radio) radio.checked = true;
  }, true);

  // Sticky toolbar under the sticky header (it hides on scroll down and returns on scroll up).
  const root = document.documentElement;
  let ticking = false;
  function placeToolbar() {
    ticking = false;
    const head = document.querySelector('store-header[data-is-sticky="true"]');
    let top = 0;
    if (head) {
      const r = head.getBoundingClientRect();
      if (r.bottom > 0) top = Math.round(r.bottom);
    }
    root.style.setProperty('--shc-sticky-top', `${top}px`);
  }
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(placeToolbar); } }, { passive: true });
  window.addEventListener('resize', placeToolbar, { passive: true });
  placeToolbar();
})();
